import { createContext } from 'react';

import {
  ServiceMatrixColumn,
  ServiceMatrixRow,
} from '@totem/components/portfolio/serviceMatrix/types';

interface Context {
  loading: boolean;
  columns: ServiceMatrixColumn[];
  rows: ServiceMatrixRow[];
  searchText: string;
  setSearchText: (val: string) => void;
}

const ServiceMatrixContext = createContext<Context>({
  loading: false,
  columns: [],
  rows: [],
  searchText: '',
  setSearchText: () => {},
});

export default ServiceMatrixContext;
